(function(document) {
	function hideMissingVariants() {
		var variantSelector = document.getElementById('product-select');
		
		if (variantSelector !== null) {
			var currentVariantId = variantSelector.options[variantSelector.selectedIndex].value;
			addVariantIdToLinks(currentVariantId);			
			filterVariants(currentVariantId);
		}
	}

	function addVariantIdToLinks(currentVariantId) {
		var printLink = document.getElementById('printLink');
		var links = document.querySelector('#templateSelectPopup .onh-popup-content.button-links a');
		if (printLink !== null) {
			var index = printLink.href.indexOf('&variant');
			if (index !== -1) {
				printLink.href = printLink.href.substring(0, index) + '&variant=' + currentVariantId;
			} else {
				printLink.href += '&variant=' + currentVariantId;
			}
		}
		
		if (links !== null) {
			for (var i = 0; i < links.length; i++) {
				if (index !== -1) {
					links[i].href = links[i].href.substring(0, index) + '&variant=' + currentVariantId;
				} else {
					links[i].href += '&variant=' + currentVariantId;
				}
			}	
		}
	}

	function filterVariants(currentVariantId) {
		var variantsBlock = document.getElementsByClassName('pushable__variant');
			for (var i = 0; i < variantsBlock.length; i++) {
				var variantId = variantsBlock[i].dataset.vid;
				variantsBlock[i].style.display = 'block';
				if (currentVariantId != variantId) {
					variantsBlock[i].style.display = 'none';
				}
			}	
	}

	var productForm = document.getElementById('product-form');
	if (productForm !== null) {
		productForm.addEventListener('change', hideMissingVariants);
	}
	
	hideMissingVariants();

	var urlParams = new URLSearchParams(window.location.search);
	var variant = urlParams.get('variant');
	if (variant !== null) {
		filterVariants(variant);
	}

})(document);